module.exports = __webpack_public_path__ + "img/qrcode_contact.af608a58.jpg";